export function MySQLFeaturesPage() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <h1 className="text-4xl font-bold">Features - MySQL Template</h1>
        <p className="text-lg text-muted-foreground max-w-4xl leading-relaxed">
          Comprehensive feature set for building production-ready applications.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <FeatureCard
          title="TypeORM Integration"
          features={[
            "Entity-based data modeling",
            "Automatic schema synchronization",
            "Migration system",
            "Query builder",
            "Repository pattern",
            "Transaction support"
          ]}
        />
        <FeatureCard
          title="Authentication System"
          features={[
            "JWT access & refresh tokens",
            "Token rotation & revocation",
            "Google OAuth 2.0",
            "Password hashing with bcrypt",
            "Role-based access control",
            "Device tracking"
          ]}
        />
        <FeatureCard
          title="Database Features"
          features={[
            "MySQL 8+ support",
            "Relationship management",
            "Cascade operations",
            "Indexes and constraints",
            "Connection pooling",
            "Query optimization"
          ]}
        />
        <FeatureCard
          title="Developer Tools"
          features={[
            "TypeScript strict mode",
            "Swagger API documentation",
            "Scalar API explorer",
            "ESLint configuration",
            "Hot module reloading",
            "Migration scripts"
          ]}
        />
      </div>
    </div>
  )
}

function FeatureCard({ title, features }: { title: string, features: string[] }) {
  return (
    <div className="bg-card border rounded-xl p-6 space-y-4">
      <h3 className="text-xl font-semibold">{title}</h3>
      <ul className="space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex gap-2 text-sm text-muted-foreground">
            <span className="text-primary">✓</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

